import { isNotDefined } from '@sgme/fp';

import { selectCashTile } from '@/store/cash/selectors/tile.ts';
import { cashClientIdUpdated } from '@/store/cash/slice.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { selectTab } from '@/store/tabs/selectors.ts';
import { tabsSlice } from '@/store/tabs/slice.ts';
import { selectTileIdsOfTab } from '@/store/workspace/selector.ts';

export const registerChangeClientListenersForCash = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: tabsSlice.actions.changeClient,
    effect: async (action, api) => {
      const state = api.getState();

      const tab = selectTab(state, action.payload.tabId);

      if (isNotDefined(tab)) {
        return;
      }

      const allCashIds = selectTileIdsOfTab(state, tab)
        .values()
        .filter((tileId) => selectCashTile(state, tileId) !== undefined);

      for (const tileId of allCashIds) {
        api.dispatch(cashClientIdUpdated({ tileId, clientId: action.payload.clientId, isTabClientOverriden: false }));
      }
    },
  });
};
